import { render, staticRenderFns } from "./Categorii_produse_dialog.vue?vue&type=template&id=31d73cf6"
import script from "./Categorii_produse_dialog.vue?vue&type=script&lang=js"
export * from "./Categorii_produse_dialog.vue?vue&type=script&lang=js"
import style0 from "./Categorii_produse_dialog.vue?vue&type=style&index=0&id=31d73cf6&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports